<ng-template #openerTemplate>
  <button class="court-system-dropdown justify-content-between" (click)="open()" (keydown.enter)="open()">
    <span class="court-system-dropdown__name" [class.hidden]="!isDropdownOpen">{{
      (currentCourtSystem$ | async)?.name
    }}</span>
    <ftr-icon class="court-system-dropdown__icon" icon="ChevronDown" align="Bottom"></ftr-icon>
  </button>
</ng-template>

@if (navItems$ | async) {
  <ftr-dropdown-menu-legacy
    ariaLabel="Court system dropdown menu"
    data-track-group="Court System Dropdown"
    [openerTemplate]="openerTemplate"
    [menuItems]="(navItems$ | async) ?? []"
    (isOpen)="setOpenState($event)"
  >
  </ftr-dropdown-menu-legacy>
}
